import type {Auth, Department, Language, PortaroVersion} from 'typings/portaro.be.types';
import type LoginService from 'shared/login/login.service';

export class KpFooterService {
    public static serviceName = 'kpFooterService';

    /*@ngInject*/
    constructor(public switchableLanguages: Language[],
                public currentDepartment: Department,
                public portaroVersion: PortaroVersion,
                public currentAuth: Auth,
                private loginService: LoginService,
                private FOR_ADMINISTRATION_ONLY: boolean) {
    }

    public async login(): Promise<void> {
        return this.loginService.thisPageLogged();
    }

    public get isForAdministrationOnly(): boolean {
        return this.FOR_ADMINISTRATION_ONLY;
    }
}